"use strict";
import {on, find, findIn, setAttribute} from '@elements/dom-utils';
import {onFind} from "@elements/init-modules-in-scope";

export function init() {

    onFind('.js-account-cart-copy', btn => {
        on('click', (e) => {
            let action = e.currentTarget.getAttribute('data-action');
            let id = e.currentTarget.getAttribute('data-id');

            let form = find('.js-account-cart-copy__form');
            setAttribute('action', action , form);

            findIn('.js-account-cart-copy__input', form).value = id;
        }, btn);
    });
}